import useConsorcioStore from "../../storeModules/useConsorcioStore";
import { TipoSimulacaoEnum } from "../../utils/constants";
import { CategoriaPagamento } from "../../utils/constants";
import useBotControlStore from "../../storeModules/useBotControlStore";
import findStep from "../../screens/bot/stepModules/findStep";

const ServicesPlans = () => {
  const options = [
    {
      text: "SIMULAR PLANO INTEGRAL",
      action: () => {
        const consorcioData = useConsorcioStore.getState();

        useConsorcioStore.setState({
          tipoPlano: TipoSimulacaoEnum.CREDITO_INTEGRAL,
          categoriaId:
            CategoriaPagamento[TipoSimulacaoEnum.CREDITO_INTEGRAL][
              consorcioData.tipoBem
            ],
        });

        useBotControlStore.setState({
          currentStep: findStep("pergunta_nome").index,
        });
      },
    },
    {
      text: "ESCOLHER OUTRO PRODUTO",
      action: () => {
        useBotControlStore.setState({
          currentStep: findStep("escolha_categoria").index,
        });
      },
    },
  ];

  return options;
};

export default ServicesPlans;
